import { Box, Button, Divider, Grid, IconButton, Modal, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Field } from '../miProfile/Field'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { toEnglishDate } from '../../../helpers/dateFormat';
import { DateInput } from '../DateInput';
import { unSelectEvent } from '../../../store/event/eventSlice';
import { editEvent } from '../../helpers/event';
import { style } from '../../../helpers/editStyle';

export const EditEvent = ({ setHidden, setReloadData }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.event)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm({ ...dataToAction, eventDate: toEnglishDate(dataToAction.eventDate) });

    const { name, eventDate, url } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectEvent())
        setHidden(false)
    }
    const onSubmit = (e) => {
        e.preventDefault();
        editEvent(formValues, t('addevent.succesEditMsg'), t('addevent.errorMsg'), t('error.errorNameDup'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('addevent.editEvent')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <Field translation='addevent' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>
                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <DateInput translation='addevent' name={eventDate} title='eventDate' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%'>
                            <Grid item xs={12} padding='0 5px'>
                                <Field translation='addevent' name={url} title='url' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}
